import type { ColDef } from "ag-grid-community";

export function createColumnDefs(
  columns: string[]
): { colDefs: ColDef[]; lastColumnField: string | null } {
  if (columns.length === 0) {
    return { colDefs: [], lastColumnField: null };
  }

  const lastColumnField = columns[columns.length - 1];

  const colDefs: ColDef[] = columns.map((col, index) => {
    const isLastColumn = index === columns.length - 1;
    return {
      field: col,
      sortable: true,
      filter: true,
      resizable: true,
      minWidth: 150,
      ...(isLastColumn ? { flex: 1, suppressSizeToFit: true } : {}),
      valueFormatter: (params: any) => {
        if (
          params.value === null ||
          params.value === undefined ||
          params.value === ""
        ) {
          return "—";
        }
        return params.value;
      },
      cellStyle: (params: any) => {
        if (
          params.value === null ||
          params.value === undefined ||
          params.value === ""
        ) {
          return { color: "var(--mantine-color-gray-5)" };
        }
        return null;
      },
    };
  });

  return { colDefs, lastColumnField };
}

